/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SAFc Backend
 * The 24/7 API description
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ActionsControllerGetPendingActionsCountParams,
  ActionsControllerGetPendingActionsParams,
  GetPendingActionsCountResponse,
  GetPendingActionsResponse
} from './sAFcBackend.schemas.js';

import actionsControllerGetPendingActionsCountMutator from '../response-type.js';
import actionsControllerGetPendingActionsMutator from '../response-type.js';


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const actionsControllerGetPendingActionsCount = (
    params?: ActionsControllerGetPendingActionsCountParams,
 options?: SecondParameter<typeof actionsControllerGetPendingActionsCountMutator>,signal?: AbortSignal
) => {


      return actionsControllerGetPendingActionsCountMutator<GetPendingActionsCountResponse>(
      {url: `/api/actions/pending-count`, method: 'GET',
        params, signal
    },
      options);
    }




export const getActionsControllerGetPendingActionsCountQueryKey = (params?: ActionsControllerGetPendingActionsCountParams,) => {
    return [
    `/api/actions/pending-count`, ...(params ? [params] : [])
    ] as const;
    }


export const getActionsControllerGetPendingActionsCountQueryOptions = <TData = Awaited<ReturnType<typeof actionsControllerGetPendingActionsCount>>, TError = unknown>(params?: ActionsControllerGetPendingActionsCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof actionsControllerGetPendingActionsCount>>, TError, TData>>, request?: SecondParameter<typeof actionsControllerGetPendingActionsCountMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActionsControllerGetPendingActionsCountQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof actionsControllerGetPendingActionsCount>>> = ({ signal }) => actionsControllerGetPendingActionsCount(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof actionsControllerGetPendingActionsCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActionsControllerGetPendingActionsCountQueryResult = NonNullable<Awaited<ReturnType<typeof actionsControllerGetPendingActionsCount>>>
export type ActionsControllerGetPendingActionsCountQueryError = unknown


export function useActionsControllerGetPendingActionsCount<TData = Awaited<ReturnType<typeof actionsControllerGetPendingActionsCount>>, TError = unknown>(
 params: undefined |  ActionsControllerGetPendingActionsCountParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof actionsControllerGetPendingActionsCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof actionsControllerGetPendingActionsCount>>,
          TError,
          Awaited<ReturnType<typeof actionsControllerGetPendingActionsCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof actionsControllerGetPendingActionsCountMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActionsControllerGetPendingActionsCount<TData = Awaited<ReturnType<typeof actionsControllerGetPendingActionsCount>>, TError = unknown>(
 params?: ActionsControllerGetPendingActionsCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof actionsControllerGetPendingActionsCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof actionsControllerGetPendingActionsCount>>,
          TError,
          Awaited<ReturnType<typeof actionsControllerGetPendingActionsCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof actionsControllerGetPendingActionsCountMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActionsControllerGetPendingActionsCount<TData = Awaited<ReturnType<typeof actionsControllerGetPendingActionsCount>>, TError = unknown>(
 params?: ActionsControllerGetPendingActionsCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof actionsControllerGetPendingActionsCount>>, TError, TData>>, request?: SecondParameter<typeof actionsControllerGetPendingActionsCountMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActionsControllerGetPendingActionsCount<TData = Awaited<ReturnType<typeof actionsControllerGetPendingActionsCount>>, TError = unknown>(
 params?: ActionsControllerGetPendingActionsCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof actionsControllerGetPendingActionsCount>>, TError, TData>>, request?: SecondParameter<typeof actionsControllerGetPendingActionsCountMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActionsControllerGetPendingActionsCountQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const actionsControllerGetPendingActions = (
    params?: ActionsControllerGetPendingActionsParams,
 options?: SecondParameter<typeof actionsControllerGetPendingActionsMutator>,signal?: AbortSignal
) => {


      return actionsControllerGetPendingActionsMutator<GetPendingActionsResponse>(
      {url: `/api/actions/pending`, method: 'GET',
        params, signal
    },
      options);
    }




export const getActionsControllerGetPendingActionsQueryKey = (params?: ActionsControllerGetPendingActionsParams,) => {
    return [
    `/api/actions/pending`, ...(params ? [params] : [])
    ] as const;
    }


export const getActionsControllerGetPendingActionsQueryOptions = <TData = Awaited<ReturnType<typeof actionsControllerGetPendingActions>>, TError = unknown>(params?: ActionsControllerGetPendingActionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof actionsControllerGetPendingActions>>, TError, TData>>, request?: SecondParameter<typeof actionsControllerGetPendingActionsMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActionsControllerGetPendingActionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof actionsControllerGetPendingActions>>> = ({ signal }) => actionsControllerGetPendingActions(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof actionsControllerGetPendingActions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActionsControllerGetPendingActionsQueryResult = NonNullable<Awaited<ReturnType<typeof actionsControllerGetPendingActions>>>
export type ActionsControllerGetPendingActionsQueryError = unknown


export function useActionsControllerGetPendingActions<TData = Awaited<ReturnType<typeof actionsControllerGetPendingActions>>, TError = unknown>(
 params: undefined |  ActionsControllerGetPendingActionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof actionsControllerGetPendingActions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof actionsControllerGetPendingActions>>,
          TError,
          Awaited<ReturnType<typeof actionsControllerGetPendingActions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof actionsControllerGetPendingActionsMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActionsControllerGetPendingActions<TData = Awaited<ReturnType<typeof actionsControllerGetPendingActions>>, TError = unknown>(
 params?: ActionsControllerGetPendingActionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof actionsControllerGetPendingActions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof actionsControllerGetPendingActions>>,
          TError,
          Awaited<ReturnType<typeof actionsControllerGetPendingActions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof actionsControllerGetPendingActionsMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActionsControllerGetPendingActions<TData = Awaited<ReturnType<typeof actionsControllerGetPendingActions>>, TError = unknown>(
 params?: ActionsControllerGetPendingActionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof actionsControllerGetPendingActions>>, TError, TData>>, request?: SecondParameter<typeof actionsControllerGetPendingActionsMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActionsControllerGetPendingActions<TData = Awaited<ReturnType<typeof actionsControllerGetPendingActions>>, TError = unknown>(
 params?: ActionsControllerGetPendingActionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof actionsControllerGetPendingActions>>, TError, TData>>, request?: SecondParameter<typeof actionsControllerGetPendingActionsMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActionsControllerGetPendingActionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






